import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import userDefaultPerfil from "../../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../../redux/auth/actions";
import { withRouter } from "react-router";

const SibebarDescriptorsProfiles = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userN = useSelector((store) => store.auth.name);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };
  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <div className="d-block d-sm-block d-md-none">
              <SubMenu
                title={userN ? userN : null}
                icon={
                  <img
                    src={!!userPic ? userPic : userDefaultPerfil}
                    className="user-pic"
                    alt="Imagen de perfil"
                  />
                }
              >
                <MenuItem>
                  <Link to={`/perfil-usuario/${userId}/${userType}`}>
                    Mi perfil
                  </Link>
                </MenuItem>
                {/* <MenuItem><Link to="Dashboard-Headcount">Dashboard</Link></MenuItem> */}
                {/* <MenuItem style={{ borderBottom: "2px solid white" }}>
                  <Link to={`/perfil-usuario/${userId}`}>Mi perfil</Link>
                </MenuItem> */}
                <div className="row no-gutters"></div>
                <MenuItem
                  icon={<i className="material-icons">notifications</i>}
                >
                  <Link to="/#!">Notificaciones</Link>
                </MenuItem>
                <MenuItem onClick={onSignOut}>Cerrar sesión</MenuItem>
              </SubMenu>
            </div>
            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">looks_one</i>}>
              <Link to="/descriptores-perfiles/total-de-competencias">
                Total de competencias
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">emoji_events</i>}>
              <Link to="/descriptores-perfiles/tipo-de-competencia">
                Tipo de competencia
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">emoji_events</i>}>
              <Link to="/descriptores-perfiles/compentencias">
                Competencias
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">widgets</i>}>
              <Link to="/descriptores-perfiles/areas">Áreas</Link>
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">settings_accessibility</i>}
            >
              <Link to="/descriptores-perfiles/competencias-del-descriptor">Competencias descriptor</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">straighten</i>}>
              <Link to="/descriptores-perfiles/unidad-de-medida">
                Unidad de medida
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">policy</i>}>
              <Link to="/descriptores-perfiles/políticas-y-procedimientos">
                Políticas y procedimientos
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">group_work</i>}>
              <Link to="/descriptores-perfiles/propositos">Propositos</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">school</i>}>
              <Link to="/descriptores-perfiles/nivel-de-educacion">
                Nivel de educación
              </Link>
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">perm_data_setting</i>}
            >
              <Link to="/descriptores-perfiles/áreas-de-conocimiento">
                Áreas de conocimiento
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">title</i>}>
              <Link to="/descriptores-perfiles/titulos">Títulos</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">trending_up</i>}>
              <Link to="/descriptores-perfiles/indicadores">Indicadores</Link>
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">assignment_turned_in</i>}
            >
              <Link to="/descriptores-perfiles/cursos">Cursos</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">psychology</i>}>
              <Link to="/descriptores-perfiles/conocimiento-técnico">
                Conocimientos técnicos
              </Link>
            </MenuItem>
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </>
  );
};

export default withRouter(SibebarDescriptorsProfiles);
